export const HEADER_OFFSET = 80;

export default function () {

    const header = document.querySelector('.js-header');
    const body = document.querySelector('body');

    function checkHeaderClass() {
        const rect = header.getBoundingClientRect();
        const height = Math.ceil(rect.height);
        const offset = HEADER_OFFSET;
        if (window.scrollY >= (height + offset)) {
            body.classList.add('header--fixed');
            window.setTimeout(() => {
                header.classList.add('show')
            }, 10);
        } else {
            body.classList.remove('header--fixed');
            header.classList.remove('show');
        }
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    window.addEventListener('scroll', debounce(() => {
        checkHeaderClass();
    }, 10));
    checkHeaderClass();

}
